export const LOADING_OBJECTIVE_VALUE_PILLAR = "LOADING_OBJECTIVE_VALUE_PILLAR";
export const SAVE_LOADING_OBJECTIVE_VALUE_PILLAR = "SAVE_LOADING_OBJECTIVE_VALUE_PILLAR";
export const GET_OBJECTIVE_VALUE_PILLAR = "GET_OBJECTIVE_VALUE_PILLAR";
export const FORM_FAIL = "FORM_FAIL";
export const OBJECTIVE_VALUE_PILLAR_FAIL = "OBJECTIVE_VALUE_PILLAR_FAIL";
export const LOADING_OBJECTIVE_VALUE_PILLAR_BY_ID = "LOADING_OBJECTIVE_VALUE_PILLAR_BY_ID";
export const GET_OBJECTIVE_VALUE_PILLAR_BY_ID = "GET_OBJECTIVE_VALUE_PILLAR_BY_ID";

